<script>
import Treeselect from '@riophae/vue-treeselect'

export default {
    components: {
        Treeselect
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Array, Object, null],
            default: () => []
        },
        classes: {
            type: String,
            default: ''
        },
        appendToBody: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: true
        },
        openOnFocus: {
            type: Boolean,
            default: false,
        },
        menuClass: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            treeSelectValue: this.value,
            pickedValue: this.value
        };
    },
    methods: {
        normalize(node) {
            return {id: node.id, label: node.title};
        },

        onSelect(value) {
            if (this.multiple) {
                if (!Array.isArray(this.pickedValue)) {
                    this.pickedValue = [];
                }
                this.pickedValue.push({
                    id: value.id,
                    title: value.title
                });
            } else {
                this.pickedValue = {
                    id: value.id,
                    title: value.title
                };
            }
            this.emit();
        },

        onDeselect(value) {
            if (this.multiple) {
                const index = this.pickedValue.findIndex(c => c.id === value.id);
                if (index >= 0) {
                    this.pickedValue.splice(index, 1);
                }
            } else {
                if (this.pickedValue && this.pickedValue.id === value.id) {
                    this.pickedValue = null;
                }
            }
            this.emit();
        },

        emit() {
            this.$emit('input', this.pickedValue);
        }
    },
    watch: {
        value() {
            this.treeSelectValue = this.value;
        }
    }
}
</script>

<template>
    <treeselect
        @select="onSelect"
        @deselect="onDeselect"
        @close="$emit('close')"
        :options="options"
        :clearable="false"
        :title="title"
        noChildrenText=""
        valueFormat="object"
        :multiple="multiple"
        :normalizer="normalize"
        :disabled="disabled"
        :class="classes"
        :append-to-body="appendToBody"
        :open-on-focus="openOnFocus"
        :menu-class="menuClass"
        v-model="treeSelectValue"
        :placeholder="placeholder"
    />
</template>

<style lang="css">
@import '../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css';
</style>
